// extracted by mini-css-extract-plugin
module.exports = {"modal":"c6_sg","modal__overlay":"c6_sh","modal__wrapper":"c6_sj","modal__inner":"c6_sk","modal__content":"c6_sl","modal__closeButton":"c6_sm"};